import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap'
import {DomSanitizer} from '@angular/platform-browser'
import {AnchorService} from 'dmmp-services'

@Component({
  selector: 'dmmp-modal-program-desc-simplificada',
  templateUrl: './modal-program-desc-simplificada.component.html'
})
export class ModalProgramDescSimplificadaComponent implements OnInit {
  @Input() identifier
  @Input() data: any
  @Output() categoriesOut = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  active: 0

  constructor(public activeModal: NgbActiveModal,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url)
  }

  anchor(event, data, categories) {
    if (data.indexOf('#') === 0 && data.length > 1) {
      this.categoriesOut.emit(categories)
      event.preventDefault()
      this.activeModal.close('Close click')
      setTimeout(() => {
        this.anchorCustom.emit({event: event, id: data})
      }, 100)
    }
  }
}
